import React from "react";
import { IconProp } from ".";
import { theme } from "styles/theme";
export default function PeopleIcon(props: IconProp) {
    const { width = 38, height = 31, color = "white" } = props;

    if (color === "blue") {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="-2.5 -5 24 24" fill="none">
                <ellipse cx="13.4997" cy="3.93561" rx="3.17943" ry="3.06452" fill={theme.primary500} />
                <ellipse cx="5.49974" cy="3.93561" rx="3.17943" ry="3.06452" fill={theme.primary500} />
                <path
                    d="M5.49917 13.4971H1.09517C0.490074 13.4971 0 12.9917 0 12.3699C0 11.2209 0.366722 10.0464 1.28353 9.39741C2.4437 8.57929 4.12563 8.48112 5.49917 8.4993C6.87438 8.4793 8.5563 8.57929 9.71647 9.39741C10.6333 10.0446 11 11.2191 11 12.3699C11 12.9917 10.5099 13.4971 9.90483 13.4971H5.50083H5.49917Z"
                    fill={theme.primary500}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9171 13.4976H13.499H13.5007H17.9047C18.5098 13.4976 18.9999 12.9921 18.9999 12.3704C18.9999 11.2196 18.6331 10.0451 17.7163 9.3979C16.5561 8.57978 14.8742 8.47979 13.499 8.49979C12.5971 8.48785 11.5622 8.52608 10.6294 8.78537C11.6077 9.69694 11.9999 11.3244 11.9999 12.9195C11.9999 13.1235 11.9705 13.3185 11.9171 13.4976Z"
                    fill={theme.primary500}
                />
            </svg>
        );
    }
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="-2.5 -5 24 24" fill="none">
            <ellipse cx="13.4997" cy="3.93561" rx="3.17943" ry="3.06452" fill={color} />
            <ellipse cx="5.49974" cy="3.93561" rx="3.17943" ry="3.06452" fill={color} />
            <path
                d="M5.49917 13.4971H1.09517C0.490074 13.4971 0 12.9917 0 12.3699C0 11.2209 0.366722 10.0464 1.28353 9.39741C2.4437 8.57929 4.12563 8.48112 5.49917 8.4993C6.87438 8.4793 8.5563 8.57929 9.71647 9.39741C10.6333 10.0446 11 11.2191 11 12.3699C11 12.9917 10.5099 13.4971 9.90483 13.4971H5.50083H5.49917Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9171 13.4976H13.499H13.5007H17.9047C18.5098 13.4976 18.9999 12.9921 18.9999 12.3704C18.9999 11.2196 18.6331 10.0451 17.7163 9.3979C16.5561 8.57978 14.8742 8.47979 13.499 8.49979C12.5971 8.48785 11.5622 8.52608 10.6294 8.78537C11.6077 9.69694 11.9999 11.3244 11.9999 12.9195C11.9999 13.1235 11.9705 13.3185 11.9171 13.4976Z"
                fill={color}
            />
        </svg>
    );
}
